import type { NextRouter } from "next/router";

const noop = () => undefined;

export function createStaticRouter(overrides: Partial<NextRouter> = {}): NextRouter {
  return {
    asPath: "/",
    back: noop,
    beforePopState: noop,
    basePath: "",
    defaultLocale: undefined,
    domainLocales: undefined,
    events: {
      emit: noop,
      off: noop,
      on: noop
    },
    isFallback: false,
    isLocaleDomain: false,
    isPreview: false,
    isReady: false,
    locale: undefined,
    locales: undefined,
    pathname: "/",
    prefetch: async () => undefined,
    push: async () => true,
    forward: noop,
    query: {},
    reload: noop,
    replace: async () => true,
    route: "/",
    ...overrides
  };
}
